import { render, staticRenderFns } from "./ImageCategoryList.vue?vue&type=template&id=868796c6&scoped=true"
import script from "./ImageCategoryList.vue?vue&type=script&lang=ts"
export * from "./ImageCategoryList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868796c6",
  null
  
)

export default component.exports